import { render, staticRenderFns } from "./CheckoutTemplateRadio.vue?vue&type=template&id=36481aa6"
import script from "./CheckoutTemplateRadio.vue?vue&type=script&lang=js"
export * from "./CheckoutTemplateRadio.vue?vue&type=script&lang=js"
import style0 from "./CheckoutTemplateRadio.vue?vue&type=style&index=0&id=36481aa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports